var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHaup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.525,
    height: 16.376,
    viewBox: "0 0 9.525 16.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H9.525V9.782H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-haup",
    transform: "translate(0 -0.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H9.525V9.782H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M9.525,4.891A4.828,4.828,0,0,1,4.762,9.782,4.828,4.828,0,0,1,0,4.891,4.828,4.828,0,0,1,4.762,0,4.828,4.828,0,0,1,9.525,4.891",
    transform: "translate(0 0)",
    fill: "#1a4b9a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M.438,8.329A.444.444,0,0,1,0,7.879V.45A.444.444,0,0,1,.438,0,.444.444,0,0,1,.876.45V7.879a.444.444,0,0,1-.438.45",
    transform: "translate(4.324 8.304)",
    fill: "#1a4b9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M0,1.152,1.122,0",
    transform: "translate(5.237 4.85)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M.54,2.605a.529.529,0,0,1-.382-.162.565.565,0,0,1,0-.784L1.615.163a.53.53,0,0,1,.764,0,.565.565,0,0,1,0,.784L.922,2.443a.529.529,0,0,1-.382.162",
    transform: "translate(4.847 5.263)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M0,1.152,1.122,0",
    transform: "translate(3.112 4.85)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M.54,2.6a.529.529,0,0,1-.381-.162.564.564,0,0,1,0-.784L1.615.162a.53.53,0,0,1,.763,0,.565.565,0,0,1,0,.784L.921,2.442A.529.529,0,0,1,.54,2.6",
    transform: "translate(2.087 5.263)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M0,1.152,1.122,0",
    transform: "translate(5.237 2.667)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    "data-name": "Fill 24",
    d: "M.54,2.605a.531.531,0,0,1-.382-.163.565.565,0,0,1,0-.784L1.615.162a.531.531,0,0,1,.764,0,.566.566,0,0,1,0,.784L.922,2.442a.531.531,0,0,1-.382.163",
    transform: "translate(4.847 2.428)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_26",
    "data-name": "Fill 26",
    d: "M0,1.152,1.122,0",
    transform: "translate(3.112 2.667)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_28",
    "data-name": "Fill 28",
    d: "M.54,2.605a.531.531,0,0,1-.381-.163.564.564,0,0,1,0-.784L1.615.162a.53.53,0,0,1,.763,0,.566.566,0,0,1,0,.784L.921,2.442a.531.531,0,0,1-.382.163",
    transform: "translate(2.087 2.428)",
    fill: "#fefefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHaup);
export default __webpack_public_path__ + "static/media/icon-haup.ff7623d1.svg";
export { ForwardRef as ReactComponent };